module.exports = __webpack_public_path__ + "static/media/Rod-pattern.2611c983.jpg";